const INITIAL_STATE = {
  token: "",
  currentUser: {},
  company: {},
  permissions: {},
  errorText: "",
  isAuthenticate: false,
};

export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "@authentication/SET_IS_AUTHENTICATE_SUCCESS":
      return {
        ...state,
        isAuthenticate: action.payload,
      };
    default:
      return state;
  }
}
